<template>
  <div class="collect">
    <div class="header" :style="{'background':form_set.color!=''?form_set.color:'#B3292C'}">
      <img :src="form_set.banner"/>
      <p class="title">{{form_set.title}}</p>
      <div class="content" v-html="form_set.content"></div>
    </div>
    <div class="form">
        <p class="required">真实姓名</p>
        <van-field left-icon="manager"></van-field>
        <p class="required">手机</p>
        <van-field left-icon="phone-circle"></van-field>
        <p class="required">医院名称|厂家名称</p>
        <van-field></van-field>
        <p class="required">科室</p>
        <van-field
            readonly
            clickable
            name="picker"
            :value="value"
            placeholder="点击选择"
            @click="showPicker = true"
        />
        <van-popup v-model="showPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns"
              @confirm="onConfirm"
              @cancel="showPicker = false"
            />
        </van-popup>
        <p class="required">职称</p>
        <van-field
            readonly
            clickable
            name="picker"
            :value="value"
            placeholder="点击选择"
            @click="showPicker = true"
        />
        <van-popup v-model="showPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns"
              @confirm="onConfirm"
              @cancel="showPicker = false"
            />
        </van-popup>  
    </div>
    <div class="bottom">
      <van-button @click="onSubmit" :style="{'background':form_set.color!=''?form_set.color:'#B3292C'}">提交</van-button>
    </div>
  </div>
</template>  
<script>
import {PersoanalUserInfo,MeetingsCollectInfo} from "../../../config/interface.js";
export default {
  data() {
    return {
      meeting_id:this.$route.query.meeting_id?this.$route.query.meeting_id:this.$route.query.MT_id,
      fieldArr:[],
      form_set:{},
      showPicker:false,
      columns:[]

    };
  },
  created() {
    
  },
  mounted() {
    this.getColumns();
  },
  computed: {},
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromRoute = from.path; //当前组件的实例
    });
  },
  methods: {
    getColumns(){
      const url = MeetingsCollectInfo;
      let params = {
        meeting_id:this.meeting_id
      };
      const method = "POST";
      fetch(url, params, method).then((res) => {
        if (res.code == 0) {
          let data=res.data;
					if(data.length!=0){
							this.fieldArr=data.extend_columns;
              this.form_set=data.formset;
						}
        }
      });
    },
    onSubmit(){
      if (this.form.hospital_name != null && this.form.hospital_name != "") {
        this.$dialog
          .confirm({
            message: "确保个人信息无误，确定上传？",
          })
          .then(() => {
            this.uploadFile();
            const url = VascularUserUpdate;
            let params = {
              realname: this.form.realname,
              id_card_num: this.form.id_card_num,
              birthday: this.form.birthday,
              sex: this.form.sex,
              address_province_id: this.form.address_province_id,
              address_city_id: this.form.address_city_id,
              address_info:
              this.form.address_district_name + this.form.address_info,
              hospital_province_id: this.form.address_province_id,
              hospital_city_id: this.form.address_city_id,
              hospital_name: this.form.hospital_name,
              hospital_id: this.form.hospital_id,
              department: this.form.department,
              from_next: this.form.from_next,
              email: this.form.email,
            };
            const method = "POST";
            fetch(url, params, method).then((res) => {
              if (res.code == 0) {
                common.toast("提交成功", 1000, "success", () => {
                  this.getUserInfo();
                  // this.$router.go(0);
                  let url = this.$route.query.url
                    ? this.$route.query.url
                    : null;
                  if (url) {
                    window.location.href = url;
                  } else {
                    this.$router.go(-1);
                  }
                });
              }
            });
          })
          .catch(() => {
            // on cancel
          });
      } else {
        common.toast("请选择医院", 1000, "warning", () => {});
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.collect {
  .header{
    text-align: center;
    color: white;
    padding-bottom:30px ;
    img{
      width: 70%;
      margin-top:30px ;
    }
  }
    p{
      font-size: 18px;
      line-height:60px;

    }
    .form{
      padding: 0 20px;
    }
    .required::after{
      color:red;
      content:'*';
    }
    .bottom{
      background:rgb(243, 217, 217);
      margin:20px 0 ;
      text-align: center;
      .van-button{
        margin:10px 0;
        background: $color-main;
        color: white;
        width:95%;
      }

    }
}
</style>  


// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting/Registration.vue